import React from 'react';
import { X, Trash2, AlertTriangle } from 'lucide-react';

const DeleteNewsletterModal = ({ isOpen, onClose, onConfirm, campaign }) => {
  if (!isOpen || !campaign) return null;

  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-bg-60 rounded-lg shadow-xl w-full max-w-md">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-bd-50">
          <div className="flex items-center gap-2">
            <AlertTriangle size={20} className="text-red-500" />
            <h2 className="text-lg font-semibold text-fg-50">Delete Campaign</h2>
          </div>
          <button
            onClick={onClose}
            className="p-1 text-fg-60 hover:text-fg-50 hover:bg-bg-40 rounded transition-colors"
          >
            <X size={20} />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="mb-4">
            <p className="text-fg-50 mb-2">
              Are you sure you want to delete this campaign?
            </p>
            <div className="bg-bg-40 rounded-lg p-3 border border-bd-50">
              <p className="font-medium text-fg-50">{campaign.title}</p>
              <p className="text-sm text-fg-60">{campaign.subject}</p>
              <div className="flex items-center gap-4 mt-2 text-xs text-fg-60">
                <span>Status: {campaign.status}</span>
                <span>Audience: {campaign.audienceCount?.toLocaleString()} recipients</span>
              </div>
            </div>
          </div>
          
          <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-3">
            <div className="flex items-start gap-2">
              <AlertTriangle size={16} className="text-red-600 mt-0.5 flex-shrink-0" />
              <div>
                <p className="text-sm font-medium text-red-800 dark:text-red-200">
                  This action cannot be undone
                </p>
                <p className="text-sm text-red-700 dark:text-red-300 mt-1">
                  {campaign.status === 'sent' 
                    ? 'Deleting this campaign will remove all analytics data and history.'
                    : campaign.status === 'scheduled'
                    ? 'This will cancel the scheduled send and delete the campaign.'
                    : 'This will permanently delete the draft campaign.'
                  }
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end gap-3 p-6 border-t border-bd-50 bg-bg-50">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm text-fg-60 hover:text-fg-50 hover:bg-bg-40 rounded-lg transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            className="flex items-center gap-2 px-4 py-2 text-sm bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
          >
            <Trash2 size={16} />
            Delete Campaign
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteNewsletterModal;